import { useAdAccountStore, useBrandStore } from 'stores';
import type { MasterTokenAdAccount } from 'types/integrations';
import useAdManager from './useAdManager';
import useHandleApi from './useHandleApi';

const useAdAccountMasterToken = () => {
  const { loading, handleApi } = useHandleApi({
    apiDomain: import.meta.env.VITE_PROXIMA_INTEGRATIONS_API_URL
  });

  const adAccountStore = useAdAccountStore();
  const { refreshAdAccount } = useAdManager();
  const { brand } = useBrandStore();

  /* api calls */
  const retrieveMasterTokenAdAccounts = async () => {
    const response = await handleApi({
      method: 'GET',
      endpoint: '/masterToken/adAccount'
    });

    if (response.error) return;

    adAccountStore.updateMasterTokenAdAccountsList(
      (response.data ?? []).map((account: MasterTokenAdAccount) => ({
        ...account,
        adAccountId: account.accountId,
        connected: adAccountStore.metaAdAccountsList.some(
          metaAccount => metaAccount.adAccountId === account.accountId
        )
      }))
    );
  };

  const createMasterTokenIntegration = async (adAccountId: string) =>
    handleApi({
      endpoint: `/brand/${brand.brandId}/masterToken/integration`,
      method: 'POST',
      data: {
        adAccountId
      }
    });

  const connectMasterTokenAdAccount = async (adAccount: MasterTokenAdAccount) => {
    const integrationResponse = await createMasterTokenIntegration(adAccount.adAccountId);

    if (integrationResponse.error) return null;

    await refreshAdAccount({ brandId: brand.brandId });
    return integrationResponse;
  };

  return {
    loading,
    retrieveMasterTokenAdAccounts,
    connectMasterTokenAdAccount
  };
};

export default useAdAccountMasterToken;
